import { useEffect, useState } from "react";
import Navigator from "./navigation/navigator";
import OneSignal from "react-onesignal";
import { AuthProvider } from "contexts/authContext";
import { isMobile } from "react-device-detect";
import { getClientConfig } from "services/apis/apis";
import {
  CLIENT_VERSION,
  IS_REQUIRED_RE_OPEN_PWA,
  getItem,
  saveItem,
} from "local-storage";
import { ComingSoon } from "components/commons";
import { UpdateVersion } from "components/commons/UpdateVersion";
import { ReOpenPWA } from "components/commons/ReOpenPWA";

async function runOneSignal() {
  await OneSignal.init({
    appId: process.env.REACT_APP_ONE_SIGNAL_ID!,
    allowLocalhostAsSecureOrigin: true,
  });
  OneSignal.Slidedown.promptPush();
}

function App() {
  const [isOutdated, setIsOutdated] = useState(false);
  const [version, setVersion] = useState();
  const [isRequiredReOpenPWA, setIsRequiredReOpenPWA] = useState(false);

  useEffect(() => {
    if (isMobile) runOneSignal();
  }, []);

  useEffect(() => {
    const f = async () => {
      const result = await getClientConfig();
      const currentVersion = getItem(CLIENT_VERSION);
      const version = result?.client_version;

      if (!currentVersion) {
        saveItem(CLIENT_VERSION, version);
        return;
      } else {
        if (currentVersion !== version) {
          setVersion(version);
          saveItem(CLIENT_VERSION, version);
          setIsOutdated(true);
        }

        setInterval(async () => {
          const result = await getClientConfig();

          const version = result?.client_version;

          const currentVersion = getItem(CLIENT_VERSION);

          if (currentVersion !== version) {
            setVersion(version);
            saveItem(CLIENT_VERSION, version);
            setIsOutdated(true);
          }
        }, 1000 * 60 * 1);
      }
    };
    f();
  }, []);

  useEffect(() => {
    const isRequiredReOpenPWA = JSON.parse(getItem(IS_REQUIRED_RE_OPEN_PWA)!);

    if (isRequiredReOpenPWA) {
      setIsRequiredReOpenPWA(true);
      saveItem(IS_REQUIRED_RE_OPEN_PWA, false);
    }
  }, []);

  if (isOutdated) {
    return <UpdateVersion version={version} />;
  }

  if (isRequiredReOpenPWA) {
    return <ReOpenPWA />;
  }

  return (
    <AuthProvider>
      <Navigator />
    </AuthProvider>
  );
}

export default App;
